const TIME_OF_DAY = 'hh:mm a';
const TIME_OF_DAY_24_HOURS = 'HH:mm';
const TIME_OF_DAY_HOUR_ONLY = 'h a';
const ISO_DATE = 'yyyy-MM-dd';
const ISO_YEAR = 'yyyy';
const ISO_MONTH = 'yyyy-MM';
const ISO_WEEK = 'yyyy-W';
const COLLECTION_DATE_TIME = 'ccc d LLLL - h:mm a';
const COLLECTION_DATE = 'ccc d LLLL';
const COLLECTION_TIME = 'h:mm a';

export const isoFormats = {
  TIME_OF_DAY,
  TIME_OF_DAY_24_HOURS,
  TIME_OF_DAY_HOUR_ONLY,
  ISO_DATE,
  ISO_YEAR,
  ISO_MONTH,
  ISO_WEEK,
  COLLECTION_DATE_TIME,
  COLLECTION_DATE,
  COLLECTION_TIME
};
